/*function Footer(){
    return(
        <footer className={styles.footer}>
            <div className={styles.containerFooter}>
                <Logo />
                <div className={styles.mantra}>
                    <p>A solução completa para emissão de notas de serviço.</p>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.iconTitle}>Produto</h3>
                    <ul>
                        <li><a href="#">Recursos</a></li>
                        <li><a href="/planos">Planos</a></li>
                        <li><a href="#">API</a></li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.iconTitle}>Legal</h3>
                    <ul>
                        <li><a href="#">Privacidade</a></li>
                        <li><a href="#">Termos</a></li>
                        <li><a href="#">Segurança</a></li>
                    </ul>
                </div>

                <div className={styles.copyContainer}>
                    <p className={styles.copyText}>&copy; 2025 NotaFácil. Todos os direitos reservados.</p>
                </div>
            </div>   
        </footer>
    );
}*/

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Instagram, Twitter, Youtube, Smartphone } from 'lucide-react';
import styles from './styles.module.css';
// personal components
import Logo from '../../componentes/Logo'
import { Context } from '../../context/UserContext';

function Footer() {
    const { authenticated } = useContext(Context);
    const year = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>

                {/* Brand */}
                <div className={styles.brand}>
                    {/*<div className={styles.logo}>
                        <FileText size={22} className={styles.logoIcon} />
                        <span>NotaFácil</span>
                    </div>*/}<Logo />
                    <p className={styles.tagline}>
                        A solução completa para emissão de notas de serviço para freelancers e pequenas empresas.
                    </p>
                    <div className={styles.socials}>
                        <a href="#" aria-label="Instagram" className={styles.socialLink}><Instagram size={18} /></a>
                        <a href="#" aria-label="Twitter" className={styles.socialLink}><Twitter size={18} /></a>
                        <a href="#" aria-label="Youtube" className={styles.socialLink}><Youtube size={18} /></a>
                    </div>
                </div>

                {/* Produto */}
                <div className={styles.col}>
                    <h4 className={styles.colTitle}>Produto</h4>
                    <ul className={styles.colList}>
                        <li><Link to="/#features">Recursos</Link></li>
                        <li><Link to="/planos">Planos e Preços</Link></li>
                        <li><Link to="/tutorial">Como usar</Link></li>
                        <li><Link to="/sobre">Sobre o Orçamento Digital</Link></li>
                    </ul>
                </div>

                {/* Conta */}
                <div className={styles.col}>
                    <h4 className={styles.colTitle}>
                        {authenticated ? 'Minha Conta' : 'Acesso'}
                    </h4>
                    <ul className={styles.colList}>
                        {authenticated ? (
                            <>
                                <li><Link to="/dashboard">Dashboard</Link></li>
                                <li><Link to="/planos">Alterar Plano</Link></li>
                            </>
                        ) : (
                            <>
                                <li><Link to="/login">Entrar</Link></li>
                                <li><Link to="/register">Criar Conta Grátis</Link></li>
                                <li><Link to="/planos">Ver Planos</Link></li>
                            </>
                        )}
                    </ul>
                </div>

                {/* Legal */}
                <div className={styles.col}>
                    <h4 className={styles.colTitle}>Legal</h4>
                    <ul className={styles.colList}>
                        <li><Link to="/privacidade">Política de Privacidade</Link></li>
                        <li><Link to="/termos">Termos de Uso</Link></li>
                        <li><Link to="/seguranca">Segurança</Link></li>
                    </ul>
                </div>

                {/* App Android */}
                <div className={styles.col}>
                    <h4 className={styles.colTitle}>Aplicativo</h4>
                    <p className={styles.appDesc}>Acesse pelo celular com nosso app Android</p>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.notafacil"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.appBadge}
                    >
                        <Smartphone size={18} />
                        <div>
                            <span className={styles.appBadgeSmall}>Disponível no</span>
                            <span className={styles.appBadgeBig}>Google Play</span>
                        </div>
                    </a>
                </div>

            </div>

            <div className={styles.bottom}>
                <p>&copy; {year} Orçamento Digital. Todos os direitos reservados.</p>
                <p className={styles.bottomLinks}>
                    <Link to="/privacidade">Privacidade</Link>
                    <span>·</span>
                    <Link to="/termos">Termos</Link>
                    <span>·</span>
                    <Link to="/tutorial">Tutorial</Link>
                </p>
            </div>
        </footer>
    );
}

export default Footer;
